"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var normalizeCarouselMedia_1 = __importDefault(require("../normalizeCarouselMedia"));
var normalizeSkus_1 = __importDefault(require("../normalizeSkus"));
var catalogNormalizer = function (response) {
    var _a = (response).data, _b = _a.products, products = _b === void 0 ? {} : _b, _c = _a.country_info, country_info = _c === void 0 ? {
        country_code: '',
        currency: '',
        free_shipping_threshold: null,
    } : _c;
    var skuKeysMap = {};
    var normalizedProducts = Object.entries(products).reduce(function (acc, _a) {
        var _b;
        var key = _a[0], product = _a[1];
        var skus = product.skus
            ? (0, normalizeSkus_1.default)(Object.values(product.skus))
            : null;
        skus === null || skus === void 0 ? void 0 : skus.forEach(function (sku) {
            skuKeysMap[sku.id] = key;
        });
        return __assign(__assign({}, acc), (_b = {}, _b[key] = {
            id: product.id,
            name: product.name,
            productKey: key,
            images: product.images,
            topBlurb: product.top_blurb,
            grades: product.grades,
            metadata: product.metadata,
            ageRange: product.age_range,
            displaySkuFrontend: product.display_sku_frontend,
            skus: skus,
            carouselMedia: product.carousel_medias
                ? (0, normalizeCarouselMedia_1.default)(product.carousel_medias)
                : null,
        }, _b));
    }, {});
    var normalizedCountryInfo = {
        countryCode: country_info.country_code,
        currency: country_info.currency,
        freeShippingThreshold: country_info.free_shipping_threshold,
    };
    return __assign(__assign({}, response), { data: {
            products: normalizedProducts,
            countryInfo: normalizedCountryInfo,
            skuKeysMap: skuKeysMap,
        } });
};
exports.default = catalogNormalizer;
